var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.$options.childComponent,_vm._g(_vm._b({tag:"component",attrs:{"error":_vm.error,"links":_vm.placeholders,"loading":_vm.loading,"options":_vm.texts,"value":_vm.value}},'component',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }